export default "__VITE_ASSET__8lGVYiDd__"